module.exports = import("@fortawesome/pro-regular-svg-icons/faSitemap");;